import { API_LOCATION_URL } from 'infrastructure/config';
import { ISupportUserLogoutClient, IPostInput } from 'interfaceAdapter/gatewaySchemas/ISupportUserLogoutClient';
import { getCookie } from 'utils/cookie';

const csrfToken = getCookie('csrftoken');
const PATH = `${API_LOCATION_URL}/supporter/user/logout`;

export class SupportUserLogoutClient implements ISupportUserLogoutClient {
    async post(input: IPostInput): Promise<void> {
        const { token } = input;
        const method = 'POST';
        const headers: { [key: string]: string } = {
            'Content-Type': 'application/json',
            'X-HTTP-AUTH-TOKEN-S': token,
        };

        if (csrfToken) {
            headers['X-CSRFToken'] = csrfToken;
        }

        await fetch(PATH, { method, headers });
    }
}
